var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToWatchlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "#FFFFFF",
    width: "28px",
    className: "css-13o7eu2 e16cqoze0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14-6.268 14-14 14zm1.754-12.239h4.987c.97 0 1.759-.79 1.759-1.76 0-.975-.789-1.76-1.759-1.76h-4.987V7.259c0-.973-.784-1.758-1.76-1.758-.97 0-1.758.785-1.758 1.758v4.984H7.258c-.975 0-1.758.784-1.758 1.759 0 .97.783 1.76 1.758 1.76h4.978v4.976a1.758 1.758 0 1 0 3.518 0V15.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToWatchlist);
export default __webpack_public_path__ + "static/media/addToWatchlist.c11a1ef71d609c31e97ad0bd3aceab8d.svg";
export { ForwardRef as ReactComponent };